(function(){
  function normalize(root){
    if(document.documentElement.lang.split('-')[0]!=='ar')return;
    root.querySelectorAll('a[href]').forEach(function(a){
      var u;try{u=new URL(a.getAttribute('href'),location.href);}catch(e){return;}
      if(u.origin!==location.origin || !/^\/(products|collections|pages|blogs|policies|search|cart)(\/|$)/.test(u.pathname))return;
      a.setAttribute('href','/ar'+u.pathname+u.search+u.hash);
    });
  }
  function start(){
    normalize(document);
    document.querySelectorAll('.aqh-lang__form').forEach(function(form){
      form.addEventListener('submit',function(){var input=form.querySelector('[name="return_to"]');if(input)input.value=location.pathname+location.search;});
    });
    new MutationObserver(function(records){records.forEach(function(r){r.addedNodes.forEach(function(n){if(n.nodeType===1){if(n.matches('a[href]'))normalize(n.parentNode);else normalize(n);}});});}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();